import { getCoupon, getGoodsList, apiHttp } from "../../js/axios";
import { dateStrChangeTimeTamp } from '@/utils';
import el from "element-ui/src/locale/lang/el";
import axios from 'axios'  //这里引入axios  mian无需再引
import Vue from "vue";    //引入Vue
Vue.prototype.$ajax = axios;  //修改ajax原型指向为 axios
import Qs from 'qs';
export default {
    name: 'discount',
    data() {
		var powerVerify = (rule, value, callback) => {
			if(this.noTimes) {
				callback();
			} else if(!this.noTimes && this.formData.times <= 0) {
				callback(new Error('請輸入有效次數'));
			}
			callback();
		}
		var powerVerify2 = (rule, value, callback) => {
			if(this.noTimes) {
				callback();
			} else if(!this.noTimes && this.formData2.times <= 0) {
				callback(new Error('請輸入有效次數'));
			}
			callback();
		}
		var packageVerify = (rule, value, callback) => {
			if(this.formData.goods_ids.length <= 0) {
				callback(new Error('請選擇使用產品'));
			} else {
				callback();
			}
			// callback();
		}
        return {
           searchTag: '',//查询id或手机号
           mainHeight: (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight) - 60,
           user: [],// 客户信息
           list: [],
           submiting: false,//正在请求
           
           pager: {
           	count: 0,
           	page: 1,// 默认第一页
           	pagecount: 0,
           	pagesize: 12//默认一页12条数据
           },
           pager2: {
           	count: 0,
           	page: 1,// 默认第一页
           	pagecount: 0,
           	pagesize: 12//默认一页12条数据
           },
           nowMobile: '',// 存储当前已查询企业用户id或手机号
           
           companyList: [],
           value: '0',
           alertShow: false,
           tipStatus: '',
           tipText: '',
		   remarkId: '',
		   newRemark: '',
		   oper: '',
		   isAlert: false,
		   formData: {
				code: '',
				type: '',
				remark: '',
				amount: '',
				goods_ids: [],
				exp: '',
				times: '',
				status: false,
		   },
		   typeOptions: [{
		   		value: '1',
		   		label: '固定金額',
		   	},{
		   		value: '2',
		   		label: '優惠金額',
		   	},{
		   		value: '3',
		   		label: '優惠折扣',
		   	},
		   ],
		   packageOptions: [],
		   rules: {
				code: [
					{ required: true, message: '請輸入優惠碼', trigger: 'blur' }
				],
				type: [
					{ required: true, message: '請選擇類別', trigger: 'change' }
				],
				goods_ids: [
					{ required: true, message: '請選擇使用產品', trigger: 'change' }
					// { validator: packageVerify, trigger: 'change' }
				],
				amount: [
					{ required: true, message: '請輸入優惠額度', trigger: 'blur' }
				],
				exp: [
					{ required: true, message: '請選擇有限時間', trigger: 'change' }
				],
				times: [
					{ required: true, message: '請輸入有效次數', trigger: 'blur' },
					{ validator: powerVerify, trigger: 'blur' }
				],
				remark: [
					{ required: false, message: '請輸入備註', trigger: 'change' }
				],
				status: [
					{ required: false, message: '請選擇啟用狀態', trigger: 'blur' }
				],
		   },
		   noTimes: false,
		   pickerOptions: {
		   	disabledDate(time) { // 结束时间禁用时间段
		   	  // 设置可选择的日期为今天之后的一个月内
		   		const curDate = (new Date()).getTime()
		   		return time.getTime() < curDate
		   	},
		   },
		   isUsedShow: false,
		   usedList: [],
		   oper2: '',
		   isAlert2: false,
		   disc: '',
		   formData2: {
			   sn: '',
			   num: '',
			   type: '',
			   remark: '',
			   amount: '',
			   goods_ids: [],
			   exp: '',
			   times: '',
			   status: false,
		   },
		   rules2: {
				sn: [
					{ required: true, message: '請輸入序列號', trigger: 'blur' }
				],
				num: [
					{ required: true, message: '請輸入添加個數', trigger: 'blur' }
				],
				type: [
					{ required: true, message: '請選擇類別', trigger: 'change' }
				],
				goods_ids: [
					{ required: true, message: '請選擇使用產品', trigger: 'change' }
					// { validator: packageVerify, trigger: 'change' }
				],
				amount: [
					{ required: true, message: '請輸入優惠額度', trigger: 'blur' }
				],
				exp: [
					{ required: true, message: '請選擇有限時間', trigger: 'change' }
				],
				times: [
					{ required: true, message: '請輸入有效次數', trigger: 'blur' },
					{ validator: powerVerify2, trigger: 'blur' }
				],
				remark: [
					{ required: false, message: '請輸入備註', trigger: 'change' }
				],
				status: [
					{ required: false, message: '請選擇啟用狀態', trigger: 'blur' }
				],
		   },
		   downFile: true,
		   sn1: '',
		   sn2: '',
		   downAct: 'coupon',
		   http: apiHttp() + '/v1/back/export/',
		   isAlert3: false,
		   formData3: {
			    sn1: '',
				sn2: '',
				act: 'coupon',
		   },
		   rules3: {
				sn1: [
					{ required: true, message: '請輸入開始序列號', trigger: 'blur' }
				],
				sn2: [
					{ required: true, message: '請輸入結束序列號', trigger: 'blur' }
				],
			
			}
        }
    },
	watch: {
		noTimes(newVal, oldVal) {
			if(newVal){
				this.formData.times = 0;
				this.$refs.form.validateField("times")
			}
		},
	},
    mounted() {
		this.getList()
    },
    methods: {
		resetPager(){
				this.pager =  {
           	count: 0,
           	page: 1,// 默认第一页
           	pagecount: 0,
           	pagesize: 12//默认一页12条数据
           }
		   this.pager2 =  {
           	count: 0,
           	page: 1,// 默认第一页
           	pagecount: 0,
           	pagesize: 12//默认一页12条数据
           }
		},
		formSubmit3() {
			this.$refs.form3.validate(isSuc => {
				if(isSuc){
					this.$refs.down.click();
					this.isAlert3 = false
					
				}
			
			})
		},
		handlePackage(e) {
			
		},
       confirmDialog() {
           this.alertShow = false;
       },
       closeDialog() {
           this.alertShow = false;
           //把绑定的弹窗数组 设为false即可关闭弹窗
       },
       searchDateChange(val) {
			this.pager.page = 1
			this.getList();
       },
       query() {
		   if(this.disc.trim() != '') {
			   this.pager.page = 1;
			   this.getList(this.disc);
		   }
       },
	   handleReset() {
		  this.disc = '';
		  this.pager.page = 1;
		  this.getList();
	   },
       pageChange(page) {
			this.pager.page = page;
			this.getList();
       },
	   pageChange2(page) {
	   	this.pager2.page = page;
	   	let data = {...this.pager2};
	   	data.id = this.id;
	   	data.act = "usedList";
	   	this.getusedList(data);
	   },
       showDialog(oper, id) {
			this.oper = oper;
			this.isAlert = true;
			this.handleGoodsList();
       },
	   showDialog2(oper, id) {
			this.oper2 = oper;
			this.isAlert2 = true;
			this.handleGoodsList();
	   },
	   handleGoodsList() {
			let data = {}
			// return
			getGoodsList(data).then((res) => {
				if(res.code == 200) {
					let goodsList = JSON.parse(window.atob(res.data))
					let list = []
					
					goodsList.map((goods) => {
						list.push({
							value: goods.id,
							label: goods.name,
							price: goods.price
						})
					})
					this.packageOptions = list
				}
			})
		},
       getList(disc) {
			let	data = {
				page: this.pager.page,
				pagesize: this.pager.pagesize,
			}
			if(disc) {
				data.code = disc;
				data.act = 'where';
			}
			getCoupon(data).then(res => {
				if(res.code == 200){
					if(res.data.data.length == 0){
							this.list = [];
							this.pager = {
								count: 0,
								page: 1,// 默认第一页
								pagecount: 0,
								pagesize: 12//默认一页12条数据
							}
					}else{
						this.list = res.data.data;
						
						//分页
						var pager = res.data.pager;
						for(var key in pager){
							pager[key] = parseInt(pager[key]);
						}
						this.pager = pager;
					}
				}else{
					this.resetPager()
					// this.alertShow = true;
					// this.tipStatus = "查詢失敗";
					// this.tipText = res.msg;
				}
			});	
       },
       timestampFormat(timestamp) {
			let dt = new Date(timestamp*1000),
				y = dt.getFullYear(),
				m = dt.getMonth() + 1 >= 10 ? dt.getMonth() + 1 : ('0' + (dt.getMonth() + 1)),
				d = dt.getDate() >= 10 ? dt.getDate() : ('0' + dt.getDate());
			
			return y + '/' + m + '/' + d;
       },
	   handleStatus(val) {
			getCoupon({act: 'status', id: val.id, status: val.status}).then((res) => {
				if(res.code == 200) {
					this.getList();
				} else {
					this.$myAlert2({
						type: 'fail',
						title: res.msg
					});
				}
			})
	   },
	   handleDel(id) {
	   	
	   },
	   handleToRecord(id) {
			this.pager2 = {
				count: 0, // 总条数
				page: 1, // 当前页
				pagecount: 0, // 总页数
				pagesize: 8 // 每页条
			}
			let data = {...this.pager2, id};
			this.id = id;
			data.act = "usedList";
			this.getusedList(data);
			this.isUsedShow = true;
	   },
	   getusedList(data) {
			getCoupon(data).then(res => {
				if(res.code == 200){
					this.usedList = res.data.data;
					this.pager2 = res.data.pager;
					
					// 数值可能为字符串，需转换为number
					for(var key in this.pager2){
						this.pager2[key] = parseInt(this.pager2[key]);
					}
					
				}else{
					this.$myAlert({
						type: 'fail',
						title: res.msg
					});
				}
			});
	   },
	   handleCode() {
			getCoupon({act: 'code'}).then((res) => {
				if(res.code == 200) {
					this.formData.code = res.data.code;
					this.$refs.form.validateField("code")
				} else {
					this.$myAlert({
						type: 'fail',
						title: res.msg
					});
				}
			})
	   },
	   handleRemarkId(id) {
	   	this.remarkId = id;
	   },
	   handleBlur() {
	   	this.remarkId = '';
	   },
	   handleNewRemark(id) {
			if(this.newRemark.trim() != '') {
				this.$myAlert2({
					title: '确定修改？',
					callback: () => {// 点击确认触发
						getCoupon({act: 'remark', id: id, remark: this.newRemark}).then((res) => {
							if(res.code == 200) {
								this.isAlert = false;
								this.remarkId = '';
								this.newRemark = '';
								this.getList();
							} else {
								this.$myAlert2({
									type: 'fail',
									title: res.msg
								});
							}
						})
					}
				});
			} else {
				this.$myAlert2({
					type: 'fail',
					title: '请输入备注',
					callback: () => {// 点击确认触发
						this.remarkId = '';
						this.newRemark = '';
					}
				});
			}
	   },
      formSubmit() {
      	let rex = /^[a-zA-Z0-9]{8}$/
      	if(!rex.test(this.formData.code)) {
      		this.$myAlert({
      			type: 'fail',
      			title: '优惠码为8位数字或字母'
      		});
      		
      		return
      	}
      	this.$refs.form.validate(isSuc => {
      		if(isSuc){
      			let data = {...this.formData};
      			data.act = 'add';
      			data.exp = dateStrChangeTimeTamp(data.exp);
      			data.status = data.status ? '1' : '2';
      			data.goods_ids = data.goods_ids.toString();
      			getCoupon(data).then((res) => {
      				if(res.code == 200) {
      					this.isAlert = false;
      					this.noTimes = false;
      					this.$refs.form.resetFields();
      					this.$myAlert({
      						type: 'success',
      						title: (this.oper == 'add'?'添加':'修改')+'成功'
      					});
      					this.getList();
      				} else {
      					this.$myAlert({
      						type: 'fail',
      						title: res.msg
      					});
      				}
      			})
      			
      			
      		}
      	
      	})
      },
	  formSubmit2() {
		  // let rex = /^[a-zA-Z0-9]{8}$/
		  // if(!rex.test(this.formData.code)) {
		  // 	this.$myAlert({
		  // 		type: 'fail',
		  // 		title: '优惠码为8位数字或字母'
		  // 	});
		  	
		  // 	return
		  // }
		  this.$refs.form2.validate(isSuc => {
		  	if(isSuc){
		  		let data = {...this.formData2};
		  		data.act = 'batchAdd';
		  		data.exp = dateStrChangeTimeTamp(data.exp);
		  		data.status = data.status ? '1' : '2';
		  		data.goods_ids = data.goods_ids.toString();
		  		getCoupon(data).then((res) => {
		  			if(res.code == 200) {
		  				this.isAlert2 = false;
		  				this.noTimes = false;
		  				this.$refs.form2.resetFields();
		  				this.$myAlert({
		  					type: 'success',
		  					title: res.msg
		  				});
		  				this.getList();
		  			} else {
		  				this.$myAlert({
		  					type: 'fail',
		  					title: res.msg
		  				});
		  			}
		  		})
		  		
		  		
		  	}
		  
		  })
	  },
      formCancel() {
      	this.$refs.form.resetFields();
      	this.noTimes = false;
      	this.isAlert = false;
      	this.isAlert2 = false;
      },
	  formCancel2() {
	  	this.isAlert3 = false;
	  },
    }
}